module.exports = __webpack_public_path__ + "img/step2.35542d21.svg";